import styles from './JobMailWrapper.less';

import React, { Component, PropTypes } from 'react';
import JobMail from './JobMail';
import { MailIcon } from 'seek-style-guide/react';

class JobMailWrapper extends Component {
  static propTypes = {
    prompt: PropTypes.string.isRequired
  }

  render() {
    const { prompt } = this.props;
    return (
      <section className={styles.root} data-automation="savePanel">
        <h1 className={styles.savePrompt}><MailIcon className={styles.icon} /> {prompt}</h1>
        <JobMail />
      </section>
    );
  }
}

export default JobMailWrapper;



/** WEBPACK FOOTER **
 ** ./app/components/SearchResultPage/components/SavePanel/components/JobMailNew/JobMailWrapper.js
 **/